import { createContext, ReactNode, useContext } from "react";
import useStore from "../../../stores/common/useStore";
import MainHeaderStore from "../stores/MainHeaderStore";

const MainHeaderStoreContext = createContext<MainHeaderStore | null>(null);

// eslint-disable-next-line
export const MainHeaderStoreProvicer: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const store = useStore(MainHeaderStore, []);

  return (
    <MainHeaderStoreContext.Provider value={store}>
      {children}
    </MainHeaderStoreContext.Provider>
  );
};

export const useMainHeaderStore = () => {
  const store = useContext(MainHeaderStoreContext);

  if (!store) {
    throw new Error(
      "useMainHeaderStore should be called inside MainHeaderStoreProvicer"
    );
  }

  return store;
};
